import { Brand } from '@anm/api/modules/brands';
import Dialog from '@anm/components/modals/Dialog';
import { ModalProps } from '@anm/components/modals/Modal';
import Select from '@anm/components/select/Select';
import noop from '@anm/helpers/noop';
import { useCallback, FC } from 'react';

import Wrapper, { BrandLogosContainer, ButtonWrapper, Logo, Title } from './Wrapper';
import { useSelectOptions } from './hooks';

export type BrandListModalProps = ModalProps & {
  brandList: Brand[];
  currentBrandId?: number;
  onBrandChange(brandId: number): void;
};

const BrandListModal: FC<BrandListModalProps> = ({ brandList, currentBrandId, onModalClose = noop, onBrandChange }) => {
  const [options, currentValue, logos, handleSelectChange] = useSelectOptions({
    brandList,
    currentBrandId
  });

  const handleBrandChange = useCallback(() => {
    onModalClose();
    onBrandChange(currentValue.value);
  }, [currentValue, onModalClose]);

  return (
    <Dialog {...{ onModalClose }} noMinWidth onSubmit={handleBrandChange}>
      <Wrapper>
        <Title level={4} title="Your brands and logos" />
        <Select name="brands" options={options} value={currentValue} onChange={handleSelectChange} />
        <BrandLogosContainer>
          {logos?.map(({ preview, filename }) => (
            <Logo key={preview} src={preview} alt={filename} />
          ))}
        </BrandLogosContainer>
        <ButtonWrapper size="large" variant="light-blue-lowercase" onClick={handleBrandChange}>
          Use this brand
        </ButtonWrapper>
      </Wrapper>
    </Dialog>
  );
};

export default BrandListModal;
